import { useEffect } from "react";
import { usePackageStore } from "./packageStore";

export const usePackage = ({ packageId }: { packageId: string }) => {
  const {
    data: packageData,
    fetch: getPackageData,
    loading,
  } = usePackageStore();

  useEffect(() => {
    const fetchData = async () => {
      await getPackageData({
        requestPayload: {
          id: packageId,
        },
      });
    };

    fetchData();
  }, [packageId]);

  return { packageData, loading };
};
